import actions from "~/shared/actions";
import * as server from "~/shared/api/server";

export function loadAccountTransactions(policyNumber, period) {
	return (dispatch) => {
		dispatch(actions.accountTransactionsRequest({ policyNumber, period }));
		return server.getAccountTransactions(policyNumber, period).then((json) =>
			dispatch(
				actions.accountTransactionsResponse({
					policyNumber,
					period,
					...json,
				}),
			),
		);
	};
}

export function loadAccountTransaction(policyNumber, transactionId) {
	return (dispatch) => {
		dispatch(actions.accountTransactionRequest({ policyNumber, transactionId }));
		return server.getAccountTransaction(policyNumber, transactionId).then((json) => dispatch(actions.accountTransactionResponse({ policyNumber, transaction: json })));
	};
}

export function setPeriod(period) {
	return (dispatch) => dispatch(actions.periodChanged({ period }));
}
